// Tag interfaces and types
export interface Tag {
  id: number;
  name: string;
}

export interface TagOption extends Tag {
  label: string;
  value: number;
}

// Convert Tag to TagOption for react-select
export const tagToOption = (tag: Tag): TagOption => ({
  ...tag,
  label: tag.name,
  value: tag.id,
});

// Convert TagOption back to Tag
export const optionToTag = (option: TagOption): Tag => ({
  id: option.value,
  name: option.label,
});

// Tag validation
export const isValidTagName = (name: string): boolean => {
  return name.trim().length >= 2 && name.trim().length <= 50;
};

// Tag search/filter utility
export const filterTags = (tags: Tag[], searchTerm: string): Tag[] => {
  if (!searchTerm.trim()) {
    return tags;
  }
  
  const term = searchTerm.toLowerCase().trim();
  return tags.filter(tag => 
    tag.name.toLowerCase().includes(term)
  );
};

// Tag statistics helper
export interface TagWithStats extends Tag {
  trailCount: number;
}

export const sortTagsByUsage = (tags: TagWithStats[]): TagWithStats[] => {
  return [...tags].sort((a, b) => b.trailCount - a.trailCount);
};